/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFractionClass } from '../../factoriesAny.js';
export var FractionDependencies = {
  createFractionClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFractionClass.generated.js
// module id = V24N
// module chunks = 3